import React from 'react';
import SecondaryTripReport from './SecondaryTripReport';

const SecondaryTripReportPage = () => {
  return (
    <div className="space-y-6">
      <SecondaryTripReport />
    </div>
  );
};

export default SecondaryTripReportPage;
